import { fromJS, List } from 'immutable'
import _ from 'lodash'
import { alterTrackerOptions, getFieldStateByPath } from './utils'

export const handleRenameGroup = (
  actionParams,
  params,
  component,
  layoutMode,
  retState,
  parentUID,
  isProjectElm,
  stepID,
  pageID
) => {
  const {
    renameGroupItemTarget = null,
    renameGroupItemValue = null,
    renameGroupItemType,
    fromEl = null,
  } = actionParams?.toJS()
  let labelValue = renameGroupItemType === 'field' ? params?.[fromEl] : renameGroupItemValue
  if (!labelValue) {
    labelValue = getFieldStateByPath(retState, fromEl)
  }
  const options = component.getIn(['props', layoutMode, 'options'], List())?.toJS()
  options.forEach((topOption) => {
    if (topOption.id === renameGroupItemTarget) {
      _.set(topOption, 'label', labelValue)
    }
    topOption?.options?.forEach((secondLevelOption) => {
      if (secondLevelOption.id === renameGroupItemTarget) {
        _.set(secondLevelOption, 'label', labelValue)
      }
    })
  })
  return alterTrackerOptions(retState, parentUID, isProjectElm, stepID, layoutMode, pageID, fromJS(options))
}
